import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function evaluationEquipmentList(
  accountId: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${accountId}/evaluation/equipment/list${queryString}`,
  );
}

export async function evaluationEquipmentShow(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/evaluation/equipment/${item_id}/show`,
  );
}

export async function evaluationEquipmentCreate(
  account_id: string,
  payload: {
    evaluation_id: string;
    equipment_id: string;
  },
) {
  return await clientAxios.post(
    `account/${account_id}/evaluation/equipment/create`,
    payload,
  );
}

export async function evaluationEquipmentDelete(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/evaluation/equipment/${item_id}/delete`,
  );
}

export async function evaluationEmployeeEquipmentUpload(
  account_id: string,
  item_id: string,
) {
//   return await clientAxios.del(
//     `account/${account_id}/evaluation/equipment/${item_id}/delete`,
//   );
}
